const normalizeRedirectUrl = (value) => {
  if (!value) {
    return value;
  }

  try {
    const url = new URL(value, window.location.origin);
    url.hash = "";

    if (url.pathname.length > 1 && url.pathname.endsWith("/")) {
      url.pathname = url.pathname.slice(0, -1);
    }

    return url.toString();
  } catch {
    return value;
  }
};

export const asgardeoConfig = {
  signInRedirectURL: normalizeRedirectUrl(import.meta.env.VITE_SIGN_IN_URL),
  signOutRedirectURL: normalizeRedirectUrl(import.meta.env.VITE_SIGN_OUT_URL),
  clientID: import.meta.env.VITE_ASGARDEO_CLIENT_ID,
  baseUrl: import.meta.env.VITE_ASGARDEO_BASE_URL,
  scope: import.meta.env.VITE_ASGARDEO_SCOPES
    ? import.meta.env.VITE_ASGARDEO_SCOPES.split(" ")
    : ["openid", "profile", "email", "address", "phone"],
};
